import script from "./StatusBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatusBadge.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
